export default __webpack_public_path__ + "static/media/Kollektiv35_StimmeX_Web-6.352c74cd.jpg";